import { IDropdownItem } from '@dcl/ui/dist/modules/Dropdown';
import {
  IPhoneSupportListItem,
  IPhoneSupportCountryListItem,
  IMultiplePhoneSupportItem,
} from './ContactHubTypes';
import { ISelectedDropdownListItem } from './ContactHubMultiSupportTypes';

export const getPhoneSupportListForDropwdown = (
  supportList: any
): IDropdownItem[] => {
  return supportList?.map((support: any) => {
    if ('supportType' in support) {
      return {
        label: support.supportType,
        value: support,
      };
    } else if ('countryName' in support) {
      return {
        label: support.countryName,
        value: support,
      };
    }
    return {
      label: '',
      value: support,
    };
  });
};

export const formatDropdownValue = (
  value:
    | IPhoneSupportCountryListItem
    | IPhoneSupportListItem
    | IMultiplePhoneSupportItem
    | undefined
): ISelectedDropdownListItem => {
  if (value && 'supportType' in value) {
    const supportItem = {
      phoneSupportHeading: value.supportType,
      phoneSupportDescription: value.supportTypeDescription,
      phoneSupportList: value.phoneNumberList,
      phoneSupportHoursList: value.supportHoursList,
      selectedValue: value.supportType,
    };
    return supportItem;
  } else if (value && 'countryName' in value) {
    const countryItem = {
      phoneSupportHeading: value.phoneSubTitle,
      phoneSupportList: value.phoneNumberList,
      languageList: value.languageList,
      languageHeading: value.languageTitle,
      selectedValue: value.countryName,
    };
    return countryItem;
  }

  return {};
};
